module.exports = __webpack_public_path__ + "static/media/theme-color-sample3.971b9ccb.png";